import { StarIcon as StarIconOutline } from '@heroicons/react/24/outline';
import { StarIcon as StarIconSolid } from '@heroicons/react/24/solid';
import { useMemo, useState } from 'react';
import { Stack } from 'src/core/ui';
import { useFavoriteVendorIds } from 'src/hooks/useFavoriteVendorIds';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { PurchaseVendorsWithActions } from 'src/navigations/Routes/Settings/Views/VendorManagement/Vendors/components/VendorsTable/VendorsTableColumnsConfig';
import { Feature } from 'src/WebApiController';

import * as styles from './VendorsTable.css';

interface VendorNameCellProps {
  vendorWithActions: PurchaseVendorsWithActions | null;
}

export const VendorNameCell = ({ vendorWithActions }: VendorNameCellProps) => {
  const hasFavoriteVendorsFeature = useUserHasFeature(Feature.FavoriteVendors);
  const [iconHovered, setIconHovered] = useState(false);

  const { favoriteVendorIds, setFavoriteVendorId } = useFavoriteVendorIds();

  const isFavorite = useMemo(() => {
    return (
      vendorWithActions?.vendor.id != null &&
      favoriteVendorIds.includes(vendorWithActions.vendor.id)
    );
  }, [vendorWithActions, favoriteVendorIds]);

  if (!vendorWithActions) {
    return null;
  }

  return (
    <Stack
      gap="s"
      direction="row"
      alignItems="center"
      onMouseEnter={() => setIconHovered(true)}
      onMouseLeave={() => setIconHovered(false)}
    >
      <span>{vendorWithActions?.vendor.name}</span>
      {hasFavoriteVendorsFeature && (
        <Stack
          direction="row"
          alignItems="center"
          style={{
            // Tweak to make the icon visually centered with the text
            paddingBottom: '1px',
          }}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();

            setFavoriteVendorId(vendorWithActions.vendor.id, isFavorite);
          }}
        >
          {isFavorite ? (
            <StarIconSolid className={styles.icon} />
          ) : (
            <StarIconOutline
              className={styles.icon}
              style={{ opacity: iconHovered ? 1 : 0 }}
            />
          )}
        </Stack>
      )}
    </Stack>
  );
};
